(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perunid-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const cartLink = event.target instanceof Element ? event.target.closest('[data-perunid-cart-link]') : null;
  if (cartLink) {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
      return;
    }
  }
  document.querySelectorAll('.pn-nav-group[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.pn-nav-group[open], .perunid-mobile[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
const perunidRefreshCartBadge = async () => {
  try {
    const response = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {credentials:'same-origin'});
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-perunid-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-perunid-cart-link]').forEach(el => { el.setAttribute('aria-label', 'Otwórz koszyk, liczba produktów: ' + cart.item_count); });
  } catch (error) { console.warn('Perunid: nie udało się odświeżyć licznika koszyka', error); }
};
document.addEventListener('cart:lines:update', (event) => {
  if (event.promise && typeof event.promise.finally === 'function') event.promise.finally(perunidRefreshCartBadge);
  else perunidRefreshCartBadge();
});
window.addEventListener('pageshow', perunidRefreshCartBadge);

  } catch(e) { console.error(e); }
})();
})();
